import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Payroll,
  DetailPayroll,
  PaymentPayroll,
  ImportPayroll,
  ImportManualPayrollComponent,
  ImportPayrollNote,
} from "./pages";

const payrollRoutes = [
  {
    path: "/payroll",
    element: (
      <ProtectedRoute name="payroll_payment">
        <Payroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="payroll" defaultTitle="payroll.payroll" />
    ),
  },
  {
    path: "/payroll/detail/:id",
    element: (
      <ProtectedRoute name="payroll_payment">
        <DetailPayroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"payroll.detail"} />,
  },
  {
    path: "/payroll/detail/:id/payment",
    element: (
      <ProtectedRoute name="payroll_payment">
        <PaymentPayroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"payroll.payment"} />,
  },
  {
    path: "/payroll/import",
    element: (
      <ProtectedRoute name="payroll_payment_add">
        <ImportPayroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"payroll.import"} />,
  },
  {
    path: "/payroll/manual-component-import/:id",
    element: (
      <ProtectedRoute name="payroll_payment_add">
        <ImportManualPayrollComponent />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"payroll.import_manual_payroll_component"} />
    ),
  },
  {
    path: "/payroll/payroll-note-import/:id",
    element: (
      <ProtectedRoute name="payroll_payment_add">
        <ImportPayrollNote />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"payroll.import_payroll_notes"} />
    ),
  },
];

export default payrollRoutes;
